const ChatPage = () => {
  return <div className="container chat-page">Chat Page!</div>;
};

export default ChatPage;
